import React, { Fragment } from 'react';
import { StaticQuery, graphql } from 'gatsby';

import { Data } from '../../components';

const ChaosMonkeyResources = () => (
  <StaticQuery
    query={graphql`
      query ChaosMonkeyResourcesPageData {
        file(name: { eq: "chaos-monkey__resources" }) {
          childDataYaml {
            bestPracticesAndPrinciples {
              heading
              blurb
              items {
                link
                title
              }
            }
            blogs {
              heading
              blurb
              items {
                link
                title
                logo
              }
            }
            communityAndCulture {
              heading
              blurb
              items {
                link
                title
              }
            }
            talks {
              heading
              blurb
              items {
                link
                title
              }
            }
            tools {
              heading
              blurb
              items {
                link
                title
              }
            }
            tutorials {
              heading
              blurb
              items {
                link
                title
              }
            }
          }
        }
      }
    `}
    render={data => {
      const {
        file: { childDataYaml: pageData },
      } = data;

      const renderResourceItem = item => (
        <li key={item.title}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={item.link}
            className="chaosMonkey__resourceLink u-textHeading"
          >
            <Data>{item.title}</Data>
          </a>
        </li>
      );

      return (
        <Fragment>
          <h3
            id="chaos-best-practices-principles"
            className="chaosMonkey__sectionTitle--center"
          >
            <Data>{pageData.bestPracticesAndPrinciples.heading}</Data>
          </h3>
          <div className="u-textCenter u-mb--large">
            <Data markdown>{pageData.bestPracticesAndPrinciples.blurb}</Data>
          </div>

          <ul className="blockGrid blockGrid-2@small blockGrid-3@medium">
            {pageData.bestPracticesAndPrinciples.items.map(item =>
              renderResourceItem(item)
            )}
          </ul>

          <h3 id="chaos-blogs" className="chaosMonkey__sectionTitle--center">
            <Data>{pageData.blogs.heading}</Data>
          </h3>
          <div className="u-textCenter u-mb--large">
            <Data markdown>{pageData.blogs.blurb}</Data>
          </div>
          <ul className="blockGrid blockGrid--deepMatch blockGrid-2@small blockGrid-3@medium">
            {pageData.blogs.items.map(item => (
              <li key={item.title}>
                <a
                  href={item.link}
                  className="chaosMonkey__blogLink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="chaosMonkey__blogLink-media">
                    <img src={item.logo} alt={item.title} />
                  </div>
                  <span>
                    <Data>{item.title}</Data>
                  </span>
                </a>
              </li>
            ))}
          </ul>

          <h3
            id="chaos-community-culture"
            className="chaosMonkey__sectionTitle--center u-mt--xlarge"
          >
            <Data>{pageData.communityAndCulture.heading}</Data>
          </h3>
          <div className="u-textCenter u-mb--large">
            <Data markdown>{pageData.communityAndCulture.blurb}</Data>
          </div>

          <ul className="blockGrid blockGrid-2@medium blockGrid--largeGutter">
            {pageData.communityAndCulture.items.map(item =>
              renderResourceItem(item)
            )}
          </ul>

          <h3 id="chaos-talks" className="chaosMonkey__sectionTitle--center">
            <Data>{pageData.talks.heading}</Data>
          </h3>
          <div className="u-textCenter u-mb--large">
            <Data markdown>{pageData.talks.blurb}</Data>
          </div>

          <ul className="blockGrid blockGrid-2@medium blockGrid--largeGutter">
            {pageData.talks.items.map(item => renderResourceItem(item))}
          </ul>

          <h3 id="chaos-tools" className="chaosMonkey__sectionTitle--center">
            <Data>{pageData.tools.heading}</Data>
          </h3>
          <div className="u-textCenter u-mb--large">
            <Data markdown>{pageData.tools.blurb}</Data>
          </div>

          <ul className="blockGrid blockGrid-2@medium blockGrid--largeGutter">
            {pageData.tools.items.map(item => renderResourceItem(item))}
          </ul>

          <h3
            id="chaos-tutorials"
            className="chaosMonkey__sectionTitle--center"
          >
            <Data>{pageData.tutorials.heading}</Data>
          </h3>
          <div className="u-textCenter u-mb--large">
            <Data markdown>{pageData.tutorials.blurb}</Data>
          </div>

          <ul className="blockGrid blockGrid-2@medium blockGrid--largeGutter">
            {pageData.tutorials.items.map(item => renderResourceItem(item))}
          </ul>
        </Fragment>
      );
    }}
  />
);

export default ChaosMonkeyResources;
